import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const countryPreferenceInputSchema = z.object({
  /*
   * null représente explicitement l’option
   * « Pays non renseigné ».
   */
  countryCode: z
    .string()
    .trim()
    .length(2)
    .transform((value) => value.toUpperCase())
    .nullable(),
});

export class CountryPreferenceInputDto extends createZodDto(countryPreferenceInputSchema) {}

export const countryPreferenceSchema = z.object({
  countryCode: z.string().length(2).nullable(),
  pricingCurrencyCode: z.string().min(3).max(3),
  countryNotProvided: z.boolean(),
  countryPreferenceSetAt: dateSchema,
});

export class CountryPreferenceDto extends createZodDto(countryPreferenceSchema) {}
